import { Form } from '@ui';
import styled from 'styled-components';

export const FormSC = styled(Form)`
  .ui-textfield,
  .ui-upload {
    width: 100%;
  }
` as typeof Form;
